(() => {
  class CartDrawerModel {
    constructor(options = {}) {
      this.freeShippingThresholdCents = Number(options.freeShippingThresholdCents) || 4000;
      this.currency = options.currency || 'USD';
      this.currencySymbol = options.currencySymbol || '$';
    }

    formatMoney(cents) {
      const amount = (Number(cents) || 0) / 100;
      return `${this.currencySymbol}${amount.toFixed(2)}`;
    }

    calculateShipping(totalPriceCents) {
      const current = Math.max(0, Number(totalPriceCents) || 0);
      const threshold = this.freeShippingThresholdCents;
      const isEligible = current >= threshold;
      const remainingCents = isEligible ? 0 : threshold - current;
      const percentage = threshold > 0 ? Math.min(100, Math.round((current / threshold) * 1000) / 10) : 100;
      
      let message;
      if (isEligible) {
        message = "You've unlocked free US shipping!";
      } else {
        message = `You are ${this.formatMoney(remainingCents)} away from free US shipping!`;
      }

      return {
        threshold,
        current,
        remainingCents,
        percentage,
        isEligible,
        message
      };
    }

    filterRecommendations(recommendations = [], cartItems = []) {
      if (!Array.isArray(recommendations)) return [];
      const cartProductIds = new Set(
        cartItems.map(item => String(item.product_id || item.id || ''))
      );
      return recommendations.filter(rec => !cartProductIds.has(String(rec.id)));
    }
  }

  if (typeof globalThis !== 'undefined') {
    globalThis.CartDrawerModel = CartDrawerModel;
  }
})();
